
const initialState = null;

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CHANGE_HOSPITAL':
      return { ...state, ...action.current };
    default:
      return state;
  }
};
